// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownUserSelect__root___3I159","title":"DropdownUserSelect__title___7Pwy-"};